/*
 * ConferenceCallInformationForm Messages
 *
 * This contains all the text for the ConferenceCallInformationForm component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  generalInformation: {
    id: 'CONFERENCE_CALL_INFORMATION.general_information',
    defaultMessage: 'General information',
  },
  transcriptTitle: {
    id: 'CONFERENCE_CALL_INFORMATION.transcriptTitle',
    defaultMessage:
      'Title* (appears on the generated transcript and is visible to the client)',
  },
  conferenceDate: {
    id: 'CONFERENCE_CALL_INFORMATION.conferenceDate',
    defaultMessage: 'Date',
  },
  people: {
    id: 'CONFERENCE_CALL_INFORMATION.people',
    defaultMessage: 'Participants',
  },
  tags: {
    id: 'CONFERENCE_CALL_INFORMATION.tags',
    defaultMessage: 'Tags',
  },
  createHumanTranscription: {
    id: 'CONFERENCE_CALL_INFORMATION.createHumanTranscription',
    defaultMessage: 'Generate Human transcription',
  },
  createAITranscription: {
    id: 'CONFERENCE_CALL_INFORMATION.createAITranscription',
    defaultMessage: 'Generate AI transcription',
  },
  useTwoFactorAuth: {
    id: 'CONFERENCE_CALL_INFORMATION.useTwoFactorAuth',
    defaultMessage: 'use two-factor authentication for transcription',
  },
  allowAudioDownload: {
    id: 'CONFERENCE_VIEW_INFORMATION.allowAudioDownload',
    defaultMessage: 'Allow audio download',
  },
  introMessage: {
    id: 'CONFERENCE_CALL_INFORMATION.introMessage',
    defaultMessage: 'Intro message',
  },
  language: {
    id: 'CONFERENCE_CALL_INFORMATION.language',
    defaultMessage: 'Primary language of the conference call',
  },
  clientReference: {
    id: 'CONFERENCE_CALL_INFORMATION.clientReference',
    defaultMessage: 'Client reference',
  },
  projectCode: {
    id: 'CONFERENCE_CALL_INFORMATION.projectCode',
    defaultMessage: "Project code* [eg 'PR-1234']",
  },
  specialistNumber: {
    id: 'CONFERENCE_CALL_INFORMATION.specialistNumber',
    defaultMessage: "Specialist number on project* [eg '2.12']",
  },
  client: {
    id: 'CONFERENCE_CALL_INFORMATION.client',
    defaultMessage: 'Client*',
  },
});



// WEBPACK FOOTER //
// ./components/templates/ConferenceCallInformationForm/messages.js